import { BetQLSportItem } from "./";
import { DEFAULT_TREND_TYPES } from "./configs";

const NBAConfig: BetQLSportItem = {
  id: "6666728a-d5a5-4de3-9db5-b39b4ec758d1",
  name: "NBA",
  url: "nba",
  tabName: "NBA",
  icon: "basketball",
  imagePath: "NBA",
  key: "NBA",
  lookupKey: "nba",
  favoriteLine: "spread",
  hasTeamPowerProjectionGrades: true,
  hasFGspreadPowerRating: true,
  hasFGmoneylinePowerRating: true,
  hasFGtotalPowerRating: true,
  has1HspreadPowerRating: true,
  has1HmoneylinePowerRating: true,
  has1HtotalPowerRating: true,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: false,
  hasGoals: false,
  hasInjuries: true,
  hasNews: false,
  hasLineup: true,
  hasSchedule: true,
  hasConfiguredSchedule: false,
  hasTeamSummary: true,
  hasGameFilters: true,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: true,
  hasApRank: false,
  hasConferenceDropdown: false,
  hasNewsInjuriesColumn: true,
  hasDraws: false,
  hasSharpData: true,
  hasTopTrendsData: true,
  hasPlayerProps: true,
  hasRecommendedBets: true,
  hasPopularEvents: true,
  isCollege: false,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,5,9,15,4]}',
  defaultColumnOrder: [2, 5, 9, 15, 4],
  publicThreshold: 60,
  sharpPercentThreshold: 25,
  sharpCountThreshold: 300,
  publicCountThreshold: 300,
  trendTypes: DEFAULT_TREND_TYPES,
  filters: [
    {
      name: "Spread",
      key: "spread",
      url: "spread",
    },
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline",
    },
    {
      name: "Total",
      key: "total",
      url: "totals-spread",
    },
    {
      name: "1st Half Spread",
      key: "1Hspread",
      url: "first-half-lines",
    },
    {
      name: "1st Half Moneyline",
      key: "1Hmoneyline",
      url: "first-half-moneyline",
    },
    {
      name: "1st Half Total",
      key: "1Htotal",
      url: "first-half-totals-spread",
    },
    {
      name: "2nd Half Spread",
      key: "2Hspread",
      url: "second-half-lines",
    },
    {
      name: "2nd Half Moneyline",
      key: "2Hmoneyline",
      url: "second-half-moneylines",
    },
  ],
  periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
  periodKeys: ["FG", "1H", "2H"],
  pickTypes: ["spread", "moneyline", "total", "1Hspread", "1Hmoneyline", "1Htotal", "2Hspread", "2Hmoneyline"],
};

export default NBAConfig;
